
import { Component, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { mixins } from 'vue-class-component';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  Modal,
  Heading,
  BaseText,
  ButtonPrimary,
  RoundedIcon
} from '@warrenbrasil/nebraska-web';
import { CopyMixin } from '@/modules/common/mixins/copy';
import {
  ReferralAPI,
  IReferralTriggerIndication
} from '@/modules/wealth/services/referral-api';
import { IPortfolioInvestmentSummary } from '@/modules/wealth/store/investments';
import * as trackEvents from './track-events';

const InvestmentsModule = namespace('InvestmentsModule');

const referralAPI = new ReferralAPI();

@Component({
  components: { Modal, Heading, BaseText, ButtonPrimary, RoundedIcon }
})
export default class InviteModal extends mixins(CopyMixin) {
  @InvestmentsModule.Getter('investmentCompletedSummary')
  private investmentSummary!: IPortfolioInvestmentSummary;

  readonly NebraskaColors = NebraskaColors;

  private isLoading = true;
  private hasError = false;
  private showModal = false;
  public triggerIndication = {} as IReferralTriggerIndication;
  public linkCopied = false;

  @Emit('close')
  close() {
    this.showModal = false;
  }

  mounted() {
    trackEvents.trackViewLoadIndication();
    this.loadTriggerIndication();
  }

  public async loadTriggerIndication() {
    this.isLoading = true;
    this.hasError = false;
    try {
      const portfolioId = this.investmentSummary?.portfolioApiId ?? '';
      const response = await referralAPI.getTriggerIndication(portfolioId);
      this.triggerIndication = response;
      this.showModal = response.showInviteModal;
    } catch {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  public get shouldShowModal() {
    return !(this.isLoading && this.hasError) && this.showModal;
  }

  public get activeModalState() {
    return this.linkCopied
      ? this.triggerIndication.linkScreen
      : this.triggerIndication.inviteScreen;
  }

  public get contentStyleClass() {
    return [
      'invite-modal__content',
      { 'invite-modal__content-success': this.linkCopied }
    ];
  }

  public copyInviteLink() {
    trackEvents.trackClickSendInvite();
    trackEvents.trackViewLoadLinkCopied();
    this.copyToClipboard(this.triggerIndication.inviteURL);
    this.linkCopied = true;
  }
}
